import * as React from 'react';
import classnames from 'classnames';

import { IProductInventoryInformation } from '@msdyn365-commerce-modules/retail-actions';
import { format } from '@msdyn365-commerce-modules/utilities';

export interface ICellAvailabilityProps {
    baseClassName: string;
    showAvailability: boolean;
    availability: IProductInventoryInformation | undefined;
}

function _getAvailabilityClassName(showAvailability: boolean, availability: IProductInventoryInformation | undefined): 'hidden' | 'retrieving' | 'available' | 'error' | 'not-available' {
    if (!showAvailability) {
        return 'hidden';
    }

    if (!availability) {
        return 'retrieving';
    }

    if (availability.StockLevelLabel?.startsWith('!')) {
        return 'available';
    }

    if (availability.IsProductAvailable) {
        return 'available';
    }

    if (availability.StockLevelCode === 'ERR') {
        return 'error';
    }

    return 'not-available';
}

const CellAvailability: React.FC<ICellAvailabilityProps> = ({ baseClassName, showAvailability, availability }) => {
    if (!showAvailability) {
        return null;
    }

    const availabilityClass = _getAvailabilityClassName(showAvailability, availability);
    const stockLevelLabel = availability?.StockLevelLabel?.startsWith('!')
            ? availability?.StockLevelLabel?.substring(1)
            : availability?.StockLevelLabel;
    const availabilityText = stockLevelLabel || (availabilityClass === 'error' ? 'ERROR' : '');

    return (
        <div className={`${baseClassName}__product__availability__wrapper`}>
            <div className={classnames(`${baseClassName}__product__availability`, availabilityClass)}>
                <span>
                    &nbsp;
                    {format(availabilityText, availability?.ProductAvailableQuantity.AvailableQuantity)}
                </span>
            </div>
        </div>
    );
};

export default CellAvailability;
